const buildQuizItems = (myQuiz, stimulusQuestionsInQuiz) => {
  const items = [];
  myQuiz.forEach((itemId) => {
    if (itemId in stimulusQuestionsInQuiz) {
      const questionIds = stimulusQuestionsInQuiz[itemId];
      // ensuring we don't create empty stimuli
      if ((questionIds || []).length === 0) {
        return;
      }

      items.push({
        stimulus: {
          id: itemId,
          type: 'special/embed',
          content: {
            id: itemId,
          },
        },
        questions: [
          ...questionIds.map((questionId) => ({
            id: questionId,
            type: 'special/embed',
            content: {
              id: questionId,
            },
          })),
        ],
      });
    } else {
      items.push({
        questionId: itemId,
        stimulus: {
          id: itemId,
          type: 'special/embed',
          content: {
            id: itemId,
          },
        },
      });
    }
  });
  return items;
};

export default buildQuizItems;
